import {
  BANK_CORESPONDENTS_LOADING,
  DELETE_BANK_CORESPONDENT,
  UPDATE_BANK_CORESPONDENT,
  ADD_BANK_CORESPONDENT,
  GET_BANK_CORESPONDENTS,
  SET_BANK_CORESPONDENTS,
} from "./actionTypes";

export const getBankCorespondents = params => ({
  type: GET_BANK_CORESPONDENTS,
  payload: params,
});

export const setBankCorespondents = params => ({
  type: SET_BANK_CORESPONDENTS,
  payload: params,
});

export const addBankCorespondent = (data) => ({
  type: ADD_BANK_CORESPONDENT,
  payload: data,
});

export const updateBankCorespondent = (id, data, user) => ({
  type: UPDATE_BANK_CORESPONDENT,
  payload: { id, data, user },
});

export const deleteBankCorespondent = (id, user) => ({
  type: DELETE_BANK_CORESPONDENT,
  payload: { id, user },
});

export const bankCorespondentLoading = () => ({
  type: BANK_CORESPONDENTS_LOADING,
});
